module.exports = __webpack_public_path__ + "img/link.c75a9368.svg";